import General from '../../../libs/utility/General'
import { useUserTypeInfo } from '../../../libs/customhooks/useUserTypeInfo'

export function ShowForAllowedUsersOnly({ allowedUsers = [], children, useTypeNumber = false }) {
    const { userType, userTypeNumber } = useUserTypeInfo();

    const prefferedType = useTypeNumber ? userTypeNumber : userType

    return General.hasAccessToUserType(prefferedType, allowedUsers) ? children : null;
}